import { Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { NavLink, useNavigate } from 'react-router-dom';
import { Club } from '../../models/club';
import { getClub, getClubMember } from '../../service/clubs';
import { navigateToClub } from '../../utils/club';
import ClubImage from '../ClubImage/ClubImage';

import styles from './Club.module.scss';

interface PropsProxyCustomClub {
  clubId?: number;
  club?:Club;
}

//work like a prox
const ProxyCustomClub = ({ clubId, club: clubComplete }: PropsProxyCustomClub) => {
  
  const { data: club, isFetching } = useQuery(
    ['club', clubId],
    () => getClub(clubId),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false, enabled: !!clubId && !clubComplete },
  );

  if (clubComplete && clubComplete.id) return <ClubContainer club={clubComplete}/>

  if (isFetching) return <Spin spinning={isFetching}></Spin>

  return(
    <ClubContainer club={club} />
  )
}

interface PropsClubContainer {
  club: Club;
}

const ClubContainer = ({ club }: PropsClubContainer) => {

  const { data: members, isFetching: isFetchingMembers } = useQuery(
    ['member', club.id],
    () => getClubMember(club.id, 1),
    { refetchOnMount: 'always', staleTime: 0, refetchOnWindowFocus: false, enabled: !!club.id },
  );

  return (
    <section className={styles.clubContainer}>
      <div className={styles.imageContainer}>
        <ClubImage clubName={club?.name} path={club?.pathPhoto}/>
      </div>
      <div className={styles.infoContainer}>
        <NavLink to={navigateToClub(club?.name,club?.id)}>
          <h1>{club?.name}</h1>
        </NavLink>
        <span>{members?.length || 0} {club?.limitUsers ? `\\ ${club?.limitUsers}` :  ''} participantes</span>
      </div>
    </section>
  )
}

export  { ProxyCustomClub as CustomClub , ClubContainer };